<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col>
        HTTP Method Control
        <c-switch color="info" class="float-right" label variant="pill" size="sm" defaultChecked v-model="use_method" @change="change_use_method"/>
      </b-col>
    </b-row>
    <hr>
    <b-row class="mb-3">
      <b-col>
        Method名
      </b-col>
      <b-col sm="5" class="text-left">
        IP Address(1行に1つ入力します)
        <br>
        <small class="text-danger">IPが指定されない場合は、指定されたバーチャルドメイン全体に適用されます。</small>
        <small class="text-danger">IPを指定した場合は、そのIPのみが適用されます。</small>

      </b-col>
      <b-col sm="2" class="text-left">
        ブロックモード
      </b-col>
      <b-col sm="3">
        ファイアウォールモードに依存
      </b-col>
    </b-row>
    <hr>
    <b-row class="mb-3" v-for="(m, index) in method_list" :key="'_method_'+index" :style="use_method ? '' : 'text-decoration: line-through;'">
      <b-col>
        {{ m.method.toUpperCase() }} is
        <span v-if="m.is_mode">
          <b-badge v-if="now_mode == 0" variant="secondary">Off</b-badge>
          <b-badge v-if="now_mode == 1" variant="warning">検出だけ</b-badge>
          <b-badge v-if="now_mode == 2" variant="danger">ブロック</b-badge>
        </span>
        <span v-else>
          <b-badge v-if="m.is_block" variant="danger">ブロック</b-badge>
          <b-badge v-else variant="warning">検出だけ</b-badge>
        </span>
      </b-col>
      <b-col sm="5" class="text-left" v-if="m">
        <b-form-textarea :disabled="!use_method" @update="update($event, m.method, 'ip_list')" id="ph_content" v-model="m.ip_list" :max-rows="50"></b-form-textarea>
      </b-col>
      <b-col sm="2" class="text-left" v-if="m">
        <c-switch :disabled="m.is_mode || !use_method" color="danger" label variant="pill" size="sm" defaultChecked v-model="m.is_block" @change="update($event, m.method, 'is_block')"/>
      </b-col>
      <b-col sm="3" v-if="m">
        <c-switch :disabled="!use_method" color="primary" label variant="pill" size="sm" defaultChecked v-model="m.is_mode" @change="update($event, m.method, 'is_mode')"/>
      </b-col>
    </b-row>
    <hr>

    <!-- 설명 모달 영역 -->
    <b-modal title="ブロックベース国コード"  class="modal-info" v-model="explain_modal" ok-variant="success" header-bg-variant="success" ok-only>
      <!-- <p>国番号ブロックの場合は、GEO-IP機能でIPを国番号に変換する必要があります。</p>
      <p>123.123.123.123 	&rArr; KR  </p> -->
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
